export default __webpack_public_path__ + "static/media/banner principal forta.538060ae.png";